<h1 class="mt-5">Reporte estado de secciones</h1>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0">Criterios de búsqueda</h6>
</div>
<div class="row mt-5">
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label><label
            class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroAnyoSeleccionado" (ngModelChange)="seleccionFiltro('anyo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }">
            <option [value]="0">Seleccionar</option>
            <option *ngFor="let anyo of filtroAnyos" [value]="anyo">{{anyo}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback">
            <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label><label
            class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroPeriodoSeleccionado" (ngModelChange)="seleccionFiltro('periodo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
            <option [value]="0">Seleccionar</option>
        <option *ngFor="let periodo of filtroPeriodos" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback">
            <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
		<label class="titulo_criterios-obligatorio ml-2" *ngIf="rolUsuario === 2">(obligatorio)</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroSedeSeleccionado" (ngModelChange)="seleccionFiltro('sede')"
        [ngClass]="{ 'is-invalid': submitted && tieneErrores['sede'] }">
        <option [value]="0">Seleccionar</option>
        <option *ngFor="let sede of filtroSedes" [value]="sede.sedeId">{{sede.descripcion}}</option>
        </select>
        <div *ngIf="submitted && tieneErrores['sede'] && rolUsuario === 2" class="invalid-feedback">
            <div *ngIf="tieneErrores['sede']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Jornada</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroJornadaSeleccionada" (ngModelChange)="seleccionFiltro('jornada')">
            <option [value]="0">Seleccionar</option>
            <option *ngFor="let jornada of filtroJornadas" [value]="jornada.jornadaId">{{jornada.descripcion}}</option>
        </select>
    </div>
    <div class="col-1 centrar_iconos_botones">
        <button class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR"
            alt="BUSCAR" (click)="busqueda()"><i class="bi bi-search"></i></button>
    </div>
    <div class="col-1 centrar_iconos_botones">
        <button class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top"
            title="ELIMINAR" alt="ELIMINAR" (click)="limpiarFiltros('')"><i class="bi bi-x"></i></button>
    </div>
</div>

<div class="row mt-3">
    
    <div class="col-3">
        <form [formGroup]="parametrosForm">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
            <div class="input-group mb-3">
                <mat-autocomplete #autoAsignatura="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let asignatura of filteredAsignatura | async" [value]="asignatura">
                    {{asignatura?.codigo}}
                    </mat-option>
                </mat-autocomplete>
                <input type="text" class="form-control select_criterios" placeholder="Sigla asignatura"
                    aria-describedby="basic-addon2" [formControl]="searchAsignaturaForm" formControlName="asignatura"
                    [matAutocomplete]="autoAsignatura" maxlength="50" [ngClass]="{ 'is-invalid': submitted && tieneErrores['asignatura'] }">
            </div>
        </form>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Estado</label>
        <select class="form-control select_criterios" [(ngModel)]="filtroEstadoSeleccionado">
            <option [value]="0">Seleccionar</option>
            <option *ngFor="let estado of filtroEstados" [value]="estado.id">{{estado.descripcion}}</option>
        </select>
    </div>
</div>

<!-- FIN CRITERIO DE BUSQUEDA -->
<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="error">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ error }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
  </div>

<div class="row justify-content-end mt-5">
	<button (click)="generarSolicitudReporte()" [disabled]="!habilitarBtnGenerarReporte" class="btn boton-primario mt-4 mr-4"
		data-toggle="tooltip" data-placement="top" title="GENERAR REPORTE" alt="GENERAR REPORTE"
		style="position: absolute; z-index: 1;">
		GENERAR REPORTE
	</button>
</div>
<!-- TABLA -->
<div style="margin-top: 10px;">
    <table *ngIf="renderTabla" id="tabla-estado-secciones" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla estado secciones">
        <thead class="header_tabla">
            <tr>
                <th>Id Proceso</th>
                <th>Fecha</th>
                <th>Usuario</th>
                <th>Estado del proceso</th>
                <th class="th-mensaje-observaciones">Observaciones</th>
                <th class="text-center">Descarga archivo</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let reporte of listaReportes">
                <td class="py-3"><p class="celda">{{reporte.procesoId}}</p></td>
                <td class="py-3"><p class="celda">{{reporte.fechaProceso}}</p></td>
                <td class="py-3"><p class="celda">{{reporte.usuarioCreacion}}</p></td>
                <td class="py-3">
                    <span class="badge badge-pill finalizado d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'F'">Finalizado</span>
                    <span class="badge badge-pill en_proceso d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'EP'">En proceso</span>
                    <span class="badge badge-pill error d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'ER'">Error</span>
                </td>
                <td class="py-3 td-mensaje-observaciones"><p class="celda ">{{reporte.observacion}}</p></td>
                <td class="d-flex justify-content-center py-0"><button class="btn p-0" data-toggle="tooltip" data-placement="top"
                    title="DESCARGAR REPORTE" alt="DESCARGAR REPORTE" *ngIf="reporte.estadoProceso == 'F'" (click)="obtenerReporte(reporte.procesoId)"><i class="bi bi-filetype-xlsx icono-tabla"></i></button></td>
            </tr>
        </tbody>
    </table>
    <table *ngIf="!renderTabla" id="tabla-estado-secciones" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla estado secciones">
        <thead class="header_tabla">
            <tr>
                <th>Id Proceso</th>
                <th>Fecha</th>
                <th>Usuario</th>
                <th>Estado del proceso</th>
                <th class="th-mensaje-observaciones">Observaciones</th>
                <th class="text-center">Descarga archivo</th>
            </tr>
        </thead>
    </table>
</div>

<!-- FIN TABLA -->